import { RouteObject } from "react-router";
import GuestGuard from "./components/shared/GuestGuard";
import { Navigate } from "react-router-dom";
import Login from "./pages/authentication/login";
import AuthGuard from "./components/shared/AuthGaurd";
import DashboardLayout from "./pages/navigation/DashboardLayout";
import UserCreateEdit from "./pages/authentication/register/userCreateEdit";
import TranslationList from "./pages/Translations/TranslationList";
import RolesAndPermissions from "src/pages/rolesAndPermissions/RolesAndPermissions";
import MenuGroupCreateEdit from "src/pages/menuGroup/MenuGroupCreateEdit";
import MobileUsers from "./pages/MobileUsers/MobileUsers";
import MobileUsersCreateEdit from "./pages/MobileUsers/MobileUsersCreateEdit";
import WebMethodsCreateEdit from "./pages/WebMethods/WebMethodsCreateEdit";
import WebMethodsList from "./pages/WebMethods/WebMethodsList";
import WidgetCreateEditNew from "./pages/Widget/WidgetCreateEditNew";
import WidgetsList from "./pages/Widget/WidgetsList";
import MobileUserGroups from "./pages/MobileUserGroups/MobileUserGroups";
import AppSettingsPage from "./pages/applicationSettings/AppSettingsPage";
import AdminDashboard from "./pages/AdminPanel/AdminDashboard";
import UserGroupsSummary from "./pages/userGroups/UserGroupsSummary";
import ConfigUsersSummary from "./pages/ConfigUsers/ConfigUsersSummary";
import AcceptInvitation from "./pages/authentication/register/AcceptInvitation";
import MenusTree from "./pages/menuGroup/MenusTree";
import UserProfile from "./pages/Profile/UserProfile";
import ForgotPassword from "./pages/authentication/ForgotPassword/ForgotPassword";
import SendNotification from "./pages/Notification/Notifications";
import CurrencyPage from "./pages/Currency/CurrencyPage";
import ThemeCreateEdit from "./pages/ThemeJson/ThemeCreateEdit";
import PasswordPolicyTable from "./pages/PasswordPolicy/PasswordPolicyTable";
import ChangePassword from "./pages/MobileUserAuthentication/ChangePassword";
import EmailSettings from "./pages/EmailSettings/EmailSettingsPage";
import AppThemePage from "./pages/AppTheme/AppThemePage";
import LicensePage from "./pages/License/LicensePage";

const routes: RouteObject[] = [
  {
    path: "acceptinvitation/:userEmail/:appKey",
    element: (
      <AcceptInvitation />
    ),
  },
  {
    path: "setpassword/:appKey/:username",
    element: (
      <GuestGuard>
        <ChangePassword />
      </GuestGuard>
    ),
  },
  {
    path: "forgotpassword/:appKey",
    element: (
      <GuestGuard>
        <ChangePassword />
      </GuestGuard>
    ),
  },
  {
    path: "resetpassword/:appKey",
    element: (
      <GuestGuard>
        <ChangePassword />
      </GuestGuard>
    ),
  },
  {
    path: "authentication",
    children: [
      {
        path: "",
        element: <Navigate to="/authentication/login" />,
      },
      {
        path: "*",
        element: <Navigate to="/authentication/login" />,
      },
      {
        path: "login",
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      {
        path: "resetPasswordbyuser",
        element: (
          <GuestGuard>
            <ForgotPassword />
          </GuestGuard>
        ),
      },
    ],
  },
  {
    path: "",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "*",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "/dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "/applicationsettings",
        element: <AppSettingsPage />,
      },
      {
        path: "/configusers",
        element: <ConfigUsersSummary />,
      },
      {
        path: "/ConfigAccount/AddUpdateConfigUser",
        element: <UserCreateEdit />,
      },
      {
        path: "/configuserGroups",
        element: <UserGroupsSummary />,
      },
      {
        path: "/translation",
        element: <TranslationList />,
      },
      {
        path: "/rolesandpermission",
        element: <RolesAndPermissions />,
      },
      {
        path: "/menugroup",
        element: <MenusTree />,
      },
      {
        path: "/MenuAndSubMenu/BulkInsertUpdatdeMenuAndSubMenu",
        element: <MenuGroupCreateEdit />,
      },
      {
        path: "/usergroups",
        element: <MobileUserGroups />,
      },
      {
        path: "/users",
        element: <MobileUsers />,
      },
      {
        path: "/users/InsertUpdateUsers",
        element: <MobileUsersCreateEdit />,
      },
      {
        path: "/webMethods",
        element: <WebMethodsList />,
      },
      {
        path: "/webMethodsCreateEdit",
        element: <WebMethodsCreateEdit />,
      },
      {
        path: "/widget/InsertUpdateWidget",
        element: <WidgetCreateEditNew />,
      },
      {
        path: "/widgets",
        element: <WidgetsList />,
      },
      {
        path: "/theme",
        element: <ThemeCreateEdit />,
      },
      {
        path: "/userProfile",
        element: <UserProfile />,
      },
      {
        path: "/notification",
        element: <SendNotification />,
      },
      {
        path: "/currency",
        element: <CurrencyPage />,
      },
      {
        path: "/PasswordPolicy",
        element: <PasswordPolicyTable />,
      },
      {
        path: "/emailsettings",
        element: <EmailSettings />,
      },
      {
        path: '/appTheme',
        element: <AppThemePage />
      },
      {
        path: '/license',
        element: <LicensePage />
      }
    ],
  },
];

export default routes;
